import { IonItem } from '@ionic/react';
import { IonListWrapper } from './AdhocAssetDetails.styles';
import SelectedVehicleAttachments from '../../selectedVehicleAttachments/SelectedVehicleAttachments';

interface IComponentProps {}

const AdhocAssetDetails: React.FC<IComponentProps> = () => {
  return (
    <IonListWrapper>
      {/* Header */}
      <IonItem>Adhoc Details</IonItem>
      <SelectedVehicleAttachments />
    </IonListWrapper>
  );
};

export default AdhocAssetDetails;
